import React from 'react';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

const AddressAutocomplete = ({ value, onChange, placeholder, className }) => {
  return (
    <div className={`relative ${className}`}>
      <GooglePlacesAutocomplete
        apiKey="AIzaSyBB1thRBxM3w6ugBM1AaRQgbqNVipMByoc"
        selectProps={{
          placeholder: placeholder || "Tapez une adresse...",
          value: value ? { label: value, value: value } : null,
          onChange: (selected) => {
            if (!selected) return;

            // Appel au service de géocodage pour récupérer les coordonnées
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address: selected.label }, (results, status) => {
              if (status === 'OK' && results[0]) {
                const location = results[0].geometry.location;
                onChange({
                  address: selected.label,
                  lat: location.lat(),
                  lng: location.lng()
                });
              } else {
                onChange({
                  address: selected.label,
                  lat: null,
                  lng: null
                });
              }
            });
          },
          className: "text-base",
        }}
      />
    </div>
  );
};

export default AddressAutocomplete;
